import { Button } from '@mui/material';

import { type FiltersType } from 'app/main/components/hooks/useFilters';
import useSettings from 'app/main/components/hooks/useSettings';
import ResponsiveDialog from 'app/main/components/dialogs/ResponsiveDialog';
import Search from 'app/main/components/filter/Search';

interface BoardSearchDialogProps {
	open: boolean;
	closeDialog: VoidFunction;
	module: string;
	filters: FiltersType['filters'];
	handleFilterChange: FiltersType['handleFilterChange'];
	handleFiltersApply: FiltersType['handleFiltersApply'];
	// handleFilterChangeApply: FiltersType['handleFilterChangeApply'];
}

export default function BoardSearchDialog(props: BoardSearchDialogProps) {
	const { t } = useSettings();

	return (
		<ResponsiveDialog
			open={props.open}
			onClose={props.closeDialog}
			maxWidth="xs"
			scroll="body"
			title={t('SEARCH_BUTTON')}
			content={
				<Search
					module={props.module}
					filters={props.filters}
					handleFilterChange={props.handleFilterChange}
					handleFiltersApply={props.handleFiltersApply}
					// handleFilterChangeApply={props.handleFilterChangeApply}
				/>
			}
			actions={<Button onClick={props.closeDialog}>{t('DIALOG_ACTION_CANCEL')}</Button>}
		/>
	);
}
